"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickerProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AdapterDateFns_1 = require("@mui/x-date-pickers/AdapterDateFns");
const LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
const PickerProvider = props => {
    const { children, ...rest } = props;
    return ((0, jsx_runtime_1.jsx)(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDateFns_1.AdapterDateFns, ...rest, children: children }));
};
exports.PickerProvider = PickerProvider;
//# sourceMappingURL=provider.js.map